const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInputBarUploadWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "30px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-input-bar-upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.537,5.522L8.751,10.622C8.374,11.025 7.74,11.045 7.338,10.667C6.935,10.29 6.915,9.656 7.293,9.254L13.774,2.347C13.958,2.13 14.231,1.993 14.537,1.993L14.539,1.993C14.816,1.993 15.08,2.108 15.269,2.309L21.778,9.254C22.155,9.657 22.135,10.29 21.732,10.668C21.329,11.045 20.696,11.025 20.318,10.622L15.537,5.52L15.537,20.646C15.537,21.198 15.089,21.646 14.537,21.646C13.985,21.646 13.537,21.198 13.537,20.646L13.537,5.522ZM2.069,17.413C2.069,16.861 2.517,16.413 3.069,16.413C3.621,16.413 4.069,16.861 4.069,17.413L4.069,23.347C4.069,24.806 5.27,26.007 6.729,26.007L22.347,26.007C23.806,26.007 25.007,24.806 25.007,23.347L25.007,17.413C25.007,16.861 25.455,16.413 26.007,16.413C26.559,16.413 27.007,16.861 27.007,17.413L27.007,23.347C27.007,25.903 24.903,28.007 22.346,28.007L6.729,28.007C4.173,28.007 2.069,25.903 2.069,23.347L2.069,17.413Z",
    style: {
      fill: "white"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputBarUploadWhite);
export default __webpack_public_path__ + "static/media/icon-input-bar-upload-white.8a79fe59cb29b44234e6539a94d52d70.svg";
export { ForwardRef as ReactComponent };